import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserActions = createActionGroup({
  source: 'User API',
  events: {
    'Walkthrough Clicked': emptyProps(),
  },
});

export const loadNavigationActions = createActionGroup({
  source: 'User navigation API',
  events: {
    'Load Navigation Items Success': props<{
      navigationItems: NavigationItem[];
    }>(),
    'Load Navigation Items Failure': props<{ error: Error }>(),
  },
});

export const WalkthroughModalActions = createActionGroup({
  source: 'Walkthrough Modal',
  events: {
    'Modal Closed': emptyProps(),
  },
});
